<template>
<div>
    <v-card dark class="pa-4 grey darken-3 ma-4">
        <v-toolbar dark flat dense class="grey darken-3">
            <v-toolbar-title>Картка користувача</v-toolbar-title>
            <v-btn icon @click="getDataFromApi()" title="Оновити">
                <v-icon color="grey">mdi-cached</v-icon>
            </v-btn>

        </v-toolbar>
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
            <v-card-text>
                <v-flex xs4 lg1>
                    <v-text-field v-model="f.id" label="ID" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <validation-provider v-slot="{ errors, valid }" rules="required|tel">
                        <v-text-field @keyup="_checkPhone()" prepend-icon="mdi-phone" :loading="checkLoading" v-model="f.phone" label="Телефон" :error-messages="errors" placeholder="+38(000) 000 - 0000" v-mask="maskTel"></v-text-field>
                    </validation-provider>
                </v-flex>
                <v-flex xs12 lg6>
                    <validation-provider v-slot="{ errors, valid }" rules="required">
                        <v-text-field v-model="f.surname" :error-messages="errors" label="Прізвище"></v-text-field>
                    </validation-provider>
                </v-flex>
                <v-flex xs12 lg6>
                    <validation-provider v-slot="{ errors, valid }" rules="required">
                        <v-text-field v-model="f.firstname" :error-messages="errors" label="Ім’я"></v-text-field>
                    </validation-provider>
                </v-flex>
                <v-flex xs12 lg6>
                    <validation-provider v-slot="{ errors, valid }" rules="required">
                        <v-text-field v-model="f.lastname" :error-messages="errors" label="По-батькові"></v-text-field>
                    </validation-provider>
                </v-flex>
                <v-flex xs12 lg6>
                    <validation-provider v-slot="{ errors, valid }" rules="required|email">
                        <v-text-field v-model="f.email" prepend-icon="mdi-email" :error-messages="errors" label="Email"></v-text-field>
                    </validation-provider>
                </v-flex>
                <v-flex xs12 lg4 pb-5>
                    <v-switch v-model="f.canMegogo" :success="f.canMegogo" :error="!f.canMegogo" color="primary" persistent-hint :hint="(availableMegogo ? '<span class=\'success--text\'>Доступний</span>':'<span class=\'error--text\'>Недоступний</span>')" label="Сервіс Megogo">
                        <template v-slot:message="{ message, key }">
                            <span style="red--text" v-html="message"></span>
                        </template>
                    </v-switch>
                </v-flex>
                <v-flex xs12 lg4 pb-5>
                    <v-switch v-model="f.canYoutv" :success="f.canYoutv" :error="!f.canYoutv" color="primary" persistent-hint 
                    :hint="(availableYoutv ? '<span class=\'success--text\'>Доступний</span>':'<span class=\'error--text\'>Недоступний</span>')" label="Сервіс YouTv">
                        <template v-slot:message="{ message, key }">
                            <span style="red--text" v-html="message"></span>
                        </template>
                    </v-switch>
                </v-flex>
                <v-flex xs12 lg4 pb-5>
                    <v-switch v-model="f.canEgifts" :success="f.canEgifts" :error="!f.canEgifts" color="primary" persistent-hint 
                    :hint="(availableEgifts ? '<span class=\'success--text\'>Доступний</span>':'<span class=\'error--text\'>Недоступний</span>')" label="Сервіс Подарункові сертифікати">
                        <template v-slot:message="{ message, key }">
                            <span style="red--text" v-html="message"></span>
                        </template>
                    </v-switch>
                </v-flex>
                <v-checkbox v-model="f.owner" label="Власник"></v-checkbox>
                <v-flex xs12 lg6 class="px-4 grey darken-2 mb-4">
                    <v-container class="fill-height pa-0" fluid>
                        <v-flex xs4 lg2>
                            Контрагенти:
                        </v-flex>
                        <v-flex xs8 lg10>
                            <v-list class="grey darken-2">
                                <v-list-item>
                                    <v-radio-group v-model="f.contractor">
                                        <v-radio :value="e.value" v-for="(e, i) in contractors" :key="i">
                                            <template v-slot:label>
                                                <div>{{e.label}} &nbsp; <span class="grey--text caption pl-4" v-html="e.owners"></span></div>
                                            </template>
                                        </v-radio>
                                    </v-radio-group>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                    </v-container>
                </v-flex>
                <v-flex xs12 lg6 class="px-4 grey darken-2">
                    <v-container class="fill-height px-0" fluid>
                        <v-flex xs4 lg2>
                            ТТ:
                        </v-flex>
                        <v-flex xs8 lg10>
                            <v-list class="grey darken-2">
                                <v-list-item v-for="(shop, i) in shops" :key="i">
                                    <v-list-item-content>
                                        <v-list-item-title>{{shop.address}}</v-list-item-title>
                                        <v-list-item-subtitle>{{shop.name}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                    </v-container>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="grey" @click="goBack()">
                    <v-icon color="grey">mdi-keyboard-return</v-icon> Повернутись
                </v-btn>
                <v-btn color="cardheader" text @click="submitForm()">Зберегти</v-btn>
            </v-card-actions>
        </ValidationObserver>
    </v-card>
</div>
</template>

<script>
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

import {
    mapActions
} from 'vuex'

import {
    mask
} from 'vue-the-mask'

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    directives: {
        mask
    },
    data() {
        return {
            f: {},
            maskTel: '+38(###) ###-####',
            checkLoading: false,
            contractors: [],
            shops: []
        }
    },
    methods: {
        ...mapActions(['editUser', 'setSnackbar', 'updateUser', 'touch', 'checkPhone', 'getUserContractors', 'getUserShops']),
        getDataFromApi() {
            this.touch()
                .then(() => {
                    this.editUser(this.$route.params.id)
                        .then(data => this.f = data || {})
                    this.getUserContractors(this.$route.params.id)
                        .then(data => {
                            this.contractors = data || []
                        })
                    this.getUserShops(this.$route.params.id)
                        .then(data => {
                            this.shops = data || []
                        })
                })

        },
        goBack() {
            window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel/users')
        },
        async submitForm() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) {
                this.setSnackbar(['error', 'Заповнiть усi необхiднi поля'])
            } else {
                this.updateUser(this.f)
                    .then(() => {
                        this.setSnackbar(['info', 'Успiшно збережено'])
                        this.goBack()
                    })
                    .catch(error => {
                        this.setSnackbar(['error', error])
                    })
            }
        },
        _checkPhone() {
            if (this.f.phone.length === 17) {
                this.checkLoading = true

                this.checkPhone({
                        phone: this.f.phone,
                        id: this.f.id
                    })
                    .then(data => {
                        this.checkLoading = false
                        if (data.success) {
                            this.setSnackbar(['error', "Цей номер вже існує"])
                        }
                    })
                    .catch(error => {
                        this.setSnackbar(['error', error])
                    })
            } else {
                this.checkLoading = false
            }
        }
    },
    created() {
        this.getDataFromApi()
    },
    computed: {
        availableMegogo() {
            return (
                (this.f.owner || this.contractors.find(el => el.value == this.f.contractor && el.owners != null)) &&
                this.f.contractor &&
                this.f.canMegogo &&
                this.shops.length
            )
        },
        availableYoutv() {
            return (
                (this.f.owner || this.contractors.find(el => el.value == this.f.contractor && el.owners != null)) &&
                this.f.contractor &&
                this.f.canYoutv &&
                this.shops.length
            )
        },
        availableEgifts() {
            return (
                (this.f.owner || this.contractors.find(el => el.value == this.f.contractor && el.owners != null)) &&
                this.f.contractor &&
                this.f.canEgifts &&
                this.shops.length
            )
        }
    }
}
</script>

<style>
</style>
